// components/DuplicateToggleControls.tsx
import React from 'react';
import { Paper, FormControlLabel, Switch, Tooltip } from '@mui/material';
import { colors, elevation } from '../theme';

interface DuplicateToggleControlsProps {
  showDuplicates: boolean;
  isNew: boolean;
  duplicateMatches: any[];
  onShowDuplicatesChange: (checked: boolean) => void;
  onShowDuplicatesOnSideChange: (value: boolean) => void;
}

export const DuplicateToggleControls: React.FC<DuplicateToggleControlsProps> = ({
  showDuplicates,
  isNew,
  duplicateMatches,
  onShowDuplicatesChange,
  onShowDuplicatesOnSideChange,
}) => {
  return (
    <Paper
      sx={{
        mb: 3,
        p: 2,
        alignItems: "center",
        gap: 2,
        mt: 0,
      }}
      elevation={elevation.paper}
    >
      <Tooltip
        title={
          isNew
            ? "Duplicate check is always enabled for new customers."
            : ""
        }
        placement="bottom-start"
        arrow
        disableHoverListener={!isNew}
      >
        <span>
          <FormControlLabel
            control={
              <Switch
                checked={showDuplicates}
                onChange={(_, checked) => onShowDuplicatesChange(checked)}
                disabled={isNew}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: colors.switch.duplicateThumbDisabled,
                    "& + .MuiSwitch-track": {
                      backgroundColor: colors.switch.duplicateThumb,
                    },
                  },
                  "& .MuiSwitch-switchBase": {
                    color: colors.switch.duplicateThumb,
                    "& + .MuiSwitch-track": {
                      backgroundColor: colors.switch.track,
                    },
                  },
                  "& .MuiSwitch-switchBase.Mui-disabled": {
                    color: colors.switch.duplicateThumbDisabled,
                    "& + .MuiSwitch-track": {
                      backgroundColor: colors.switch.duplicateThumb,
                      opacity: 0.6,
                    },
                  },
                }}
              />
            }
            label="Show possible duplicates"
          />
        </span>
      </Tooltip>
      <FormControlLabel
        control={
          <Switch
            defaultChecked
            onChange={(e) => onShowDuplicatesOnSideChange(e.target.checked)}
            color="primary"
            disabled={!showDuplicates || duplicateMatches.length === 0}
          />
        }
        label="Show in side panel"
      />
    </Paper>
  );
};